export default __webpack_public_path__ + "static/media/desktop.c1b7ac87.jpg";